var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAlt2Outline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.33333H12.6667C13.0203 5.33333 13.3594 5.47381 13.6095 5.72386C13.8595 5.9739 14 6.31304 14 6.66666V10.6667C14 11.0203 13.8595 11.3594 13.6095 11.6095C13.3594 11.8595 13.0203 12 12.6667 12H11.3333V14.6667L8.66667 12H6C5.82489 12.0002 5.65146 11.9658 5.48969 11.8987C5.32792 11.8317 5.18098 11.7333 5.05733 11.6093M5.05733 11.6093L7.33333 9.33333H10C10.3536 9.33333 10.6928 9.19285 10.9428 8.94281C11.1929 8.69276 11.3333 8.35362 11.3333 8V4C11.3333 3.64638 11.1929 3.30724 10.9428 3.05719C10.6928 2.80714 10.3536 2.66666 10 2.66666H3.33333C2.97971 2.66666 2.64057 2.80714 2.39052 3.05719C2.14048 3.30724 2 3.64638 2 4V8C2 8.35362 2.14048 8.69276 2.39052 8.94281C2.64057 9.19285 2.97971 9.33333 3.33333 9.33333H4.66667V12L5.05733 11.6093Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlt2Outline);
export default __webpack_public_path__ + "static/media/ChatAlt2Outline.e298dcf0fc1c3e68665b0da5c953ba04.svg";
export { ForwardRef as ReactComponent };